import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@ontruck/orc';

import SearchField from './SearchField';
import SearchResults from './SearchResults';

import { useSearcher } from './hooks';
import { useDispatch, useSelector } from 'react-redux';
import { openShipperOrderDetail } from 'redux/modules/shipper-orders/effects';
import { openJourneyDetail } from 'redux/modules/journeys/effects';
import cx from 'classnames';
import { constants, getSpecificClientConfig } from '../../redux/modules/client-config/selectors';

const Searcher = ({ className, simplifiedSelector }) => {
  const dispatch = useDispatch();
  const simplified = useSelector(simplifiedSelector) === true;
  const {
    opened,
    focused,
    loading,
    error,
    handleClick,
    handleMouseDown,
    handleBlur,
    handleFocus,
    handleClear,
    handleKeyUp,
    handleChange,
    selectedIndex,
    value,
    options,
  } = useSearcher({
    openShipperOrderDetail: (id) =>
      dispatch(openShipperOrderDetail({ id, forceRedirectToDetailOrder: true })),
    openJourneyDetail: (payload) => dispatch(openJourneyDetail(payload)),
    simplified: simplified,
  });

  return (
    <div className={className} data-testid="searcher">
      <SearchField
        onFocus={handleFocus}
        onKeyUp={handleKeyUp}
        value={value}
        onBlur={handleBlur}
        onChange={handleChange}
        error={error}
        simplified={simplified}
      />
      {!!opened && (
        <SearchResults
          onItemClick={handleClick}
          options={options}
          selectedIndex={selectedIndex}
          loading={loading}
          onMouseDown={handleMouseDown}
        />
      )}
      {!!value ? (
        <button
          type="button"
          className={cx('searcher-button', { focused })}
          onClick={handleClear}
          data-testid="searcher-button_clear"
        >
          <Icon glyph="close" size="1.5rem" color="primary" />
        </button>
      ) : (
        <button
          type="button"
          className={cx('searcher-button', 'searcher-button__search', { focused })}
        >
          <Icon glyph="search" size="1.5rem" color="primary" />
        </button>
      )}
    </div>
  );
};

Searcher.propTypes = {
  className: PropTypes.string,
  openShipperOrderDetail: PropTypes.func,
  openJourneyDetail: PropTypes.func,
  simplifiedSelector: PropTypes.func,
};

Searcher.defaultProps = {
  simplifiedSelector: (state) => getSpecificClientConfig(state, constants.SIMPLIFIED_SEARCH_BOX),
};

export default Searcher;
